import React, { useEffect, useRef, useContext } from 'react';
import PropTypes from 'prop-types';
import BackSocketContext from 'contexts/back_socket/context';

const BackProvider = ({ channel, channelParams, onConnected, onDisconnected, onInitialized, onRejected, onReceived }) => {
  const context = useContext(BackSocketContext);
  const channelObject = useRef();

  const subscribe = () => {
    channelObject.current = context.cable.subscriptions.create(
      {
        channel,
        ...channelParams,
      },
      {
        connected: onConnected,
        disconnected: onDisconnected,
        rejected: onRejected,
        received: onReceived,
        initialized: onInitialized,
      },
    );
  };

  const unsubscribe = () => {
    if (channelObject.current) {
      channelObject.current.unsubscribe();
    }
  };

  useEffect(() => {
    subscribe();
    return () => {
      unsubscribe();
    };
  }, []);

  return null;
};

BackProvider.defaultProps = {
  channelParams: {},
};

BackProvider.propTypes = {
  channel: PropTypes.string.isRequired,
  onReceived: PropTypes.func.isRequired,
  channelParams: PropTypes.object,
  onConnected: PropTypes.func,
  onDisconnected: PropTypes.func,
  onInitialized: PropTypes.func,
  onRejected: PropTypes.func,
};

export default BackProvider;
